import { useState } from 'react'
import type { Blocker } from 'react-router-dom'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Save } from 'lucide-react'

interface UnsavedChangesDialogProps {
  blocker: Blocker
  onSave?: () => Promise<boolean>
}

export function UnsavedChangesDialog({ blocker, onSave }: UnsavedChangesDialogProps) {
  const [saving, setSaving] = useState(false)

  if (blocker.state !== 'blocked') return null

  const handleStay = () => {
    blocker.reset?.()
  }

  const handleLeave = () => {
    blocker.proceed?.()
  }

  const handleSaveAndLeave = async () => {
    if (!onSave) return
    setSaving(true)
    try {
      const success = await onSave()
      if (success) {
        blocker.proceed?.()
      } else {
        blocker.reset?.()
      }
    } catch {
      blocker.reset?.()
    } finally {
      setSaving(false)
    }
  }

  return (
    <AlertDialog open onOpenChange={(open) => { if (!open) handleStay() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Modifications non sauvegardées</AlertDialogTitle>
          <AlertDialogDescription>
            Vous avez des modifications en cours sur le plan d'action. Que souhaitez-vous faire ?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={handleStay} disabled={saving}>
            Rester sur la page
          </AlertDialogCancel>
          <AlertDialogAction variant="outline" onClick={handleLeave} disabled={saving}>
            Quitter sans sauvegarder
          </AlertDialogAction>
          {onSave && (
            <AlertDialogAction onClick={handleSaveAndLeave} disabled={saving}>
              <Save className="size-4 mr-1.5" />
              {saving ? 'Sauvegarde…' : 'Sauvegarder et quitter'}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
